// extracted by mini-css-extract-plugin
export default {"wrapperComponent":"OffersDedicated_wrapperComponent__jSCBi","header":"OffersDedicated_header__KJMTT","searchFormWrapper":"OffersDedicated_searchFormWrapper__JEJfC"};